import React, { useContext, useEffect } from "react";

import { Grid, Grow } from "@material-ui/core";

import Card from "../../../../components/cards/Card";
import TextField from "../../../../components/basics/TextFieldErp";
import Select from "../../../../components/basics/SelectErp";

import { Margin } from "../styles/Emissao";
import useCalculosTributacao from "../controllers/RulesEmissaoCalculosTributacao";

import { AplicaveisBc } from "./RulesEmissaoTributacao";

import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";
import { EmissaoContext } from "../contexts/EmissaoContext";

const TabEmissaoPIS = ({ ...props }) => {
  const {
    productPisSituation,
    setProductPisSituation,
    productPisPercentAliquot,
    setProductPisPercentAliquot,
    productPisAliquot,
    setProductPisAliquot,
    productPisBcValue,
    setProductPisBcValue,
    productPisValue,
    setProductPisValue,
    prodcuctPisListSituation,
    productError,
    productCheckPisFreight,
    setProductCheckPisFreight,
    productCheckPisSafe,
    setProductCheckPisSafe,
    productCheckPisOthers,
    setProductCheckPisOthers,
    productCheckPisDiscount,
    setProductCheckPisDiscount,
    productCheckPisDescIcms,
    setProductCheckPisDescIcms,
  } = useContext(ParametrosProdutoContext);

  const { visualizationOnly, nfeMontageSubtype } = useContext(EmissaoContext);

  const { handleCalcPis, handlePisSituation } = useCalculosTributacao();

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handlePisSituation();
  }, [handlePisSituation, nfeMontageSubtype]);

  useEffect(() => {
    if (nfeMontageSubtype === "DI") return;
    handleCalcPis();
  }, [handleCalcPis, nfeMontageSubtype]);

  return (
    <Grid container spacing={2}>
      {AplicaveisBc({
        frete: productCheckPisFreight,
        setFrete: setProductCheckPisFreight,
        seguro: productCheckPisSafe,
        setSeguro: setProductCheckPisSafe,
        desconto: productCheckPisDiscount,
        setDesconto: setProductCheckPisDiscount,
        outras: productCheckPisOthers,
        setOutras: setProductCheckPisOthers,
        descIcms: productCheckPisDescIcms,
        setDescIcms: setProductCheckPisDescIcms,
      })}
      <Grow in={true}>
        <Grid item sm={12}>
          <Card line="left">
            <Margin top="10">
              <Grid container spacing={2}>
                <Grid item sm={12}>
                  <Select
                    variant="filled"
                    value={productPisSituation}
                    setValue={setProductPisSituation}
                    descriptionField="label"
                    label="Situação Tributária PIS"
                    optionsList={prodcuctPisListSituation}
                    error={productError.productPisSituation ? true : false}
                    helperText={productError.productPisSituation || ""}
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={3}>
                  <TextField
                    value={productPisBcValue}
                    setValue={setProductPisBcValue}
                    size="small"
                    label="BC do PIS R$"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={3}>
                  <TextField
                    value={productPisPercentAliquot}
                    setValue={setProductPisPercentAliquot}
                    size="small"
                    label="Aliquota do PIS %"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={3}>
                  <TextField
                    value={productPisAliquot}
                    setValue={setProductPisAliquot}
                    size="small"
                    label="Aliquota do PIS R$"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={3}>
                  <TextField
                    value={productPisValue}
                    setValue={setProductPisValue}
                    size="small"
                    label="Valor do PIS R$"
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
              </Grid>
            </Margin>
          </Card>
        </Grid>
      </Grow>
    </Grid>
  );
};

export default TabEmissaoPIS;
